import { render } from "./ScanStickerOperateModal.vue?vue&type=template&id=37e8a0d6&ts=true&lang=pug"
import script from "./ScanStickerOperateModal.vue?vue&type=script&lang=ts"
export * from "./ScanStickerOperateModal.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__